<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <div class="main_body">
      <img src="/img/updatesetting.png" width="800" />
    </div>
    <div class="footer">
      <div class="flex items-center justify-center"><a href="http://beian.miit.gov.cn/" rel="noreferrer" target="_blank">浙ICP备2025172140号</a><a class="text-color" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33021102001155" rel="noreferrer" target="_blank"> <img src="https://beian.mps.gov.cn/web/assets/logo01.6189a29f.png" class="w-full" style="width: 16px;">浙公网安备33021102001155号</a></div>
      <!-- <div class="flex items-center justify-center"><a href="http://beian.miit.gov.cn/" rel="noreferrer" target="_blank">浙ICP备2025172140号</a><img src="/img/备案图标.png" style="width: 16px;" /><a href="https://beian.mps.gov.cn/#/query/webSearch?code=33021102001155" rel="noreferrer" target="_blank">浙公网安备33021102001155号</a></div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
.main_body {width:100%;}
.footer{width:100%;}
.left {float: left;}
</style>
